import { useTranslation } from "../../../localization/useTranslation.ts";
import { useCustomField } from "./customField.hooks.ts";
import { DotLegalSelectOption } from "../../../common/components/dotLegalMultiSelect/DotLegalMultiSelect.types.ts";
import { DotLegalMultiSelect } from "@dotlegal/dotlegal-ui-components";
import { isNullOrWhitespace, setFirstLetterToLowerCase } from "../../../common/stringOperations.ts";
import { InputFieldTypeEnum } from "../../inputFields/InputFields.types.ts";
import React from "react";

import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";

export interface CustomMultiSelectFieldProps {
    /** Lets a caller that owns the vertical rhythm itself turn the field's own margin off. */
    noMargin?: boolean;
    /** Puts the label above the input with the help icon beside it, for a form laid out that way. */
    useFixedLabel?: boolean;
    isLoading: boolean;
    entityId: string;
    entityApiPath: string;
    customInputFieldId: string;
    fieldName: string;
    fieldDescription: string | undefined;
    values: Array<string>;
    onChange: (changeFunc: (entity: any) => void) => void;
    readOnly?: boolean;
    isDisabled: boolean;
    errorText?: string;
    isPreview: boolean;
}

function CustomMultiSelectField(props: CustomMultiSelectFieldProps) {
    const { translateString } = useTranslation();
    const { onFieldChange } = useCustomField(props.entityApiPath, props.entityId, props.customInputFieldId, props.onChange);

    const url = `/settings/input-fields/${props.customInputFieldId}/select-options`;
    const { isLoading, data } = useDotLegalQuery<Array<DotLegalSelectOption>>(url, {
        enabled: !props.isPreview,
    });

    return (
        <DotLegalMultiSelect
            noMargin={props.noMargin}
            useFixedLabel={props.useFixedLabel}
            isLoading={props.isLoading || isLoading}
            options={data ?? []}
            chosenOptions={props.values}
            onChange={
                props.readOnly
                    ? () => {}
                    : (values) => {
                          onFieldChange(values);
                      }
            }
            label={props.fieldName!}
            toolTipText={props.fieldDescription}
            noOptionsLabel={translateString("noOptions")}
            disabled={props.isDisabled}
            errorText={props.errorText}
            helperText={
                props.isPreview ? translateString(setFirstLetterToLowerCase(InputFieldTypeEnum[InputFieldTypeEnum.MultiDropDown].toString())) : undefined
            }
        />
    );
}

export default CustomMultiSelectField;
